<template>
  <div class='work_box'>
    <div v-if='passEqment' class='tip_box'>
      <img style='vertical-align:middle;margin-right:16px;margin-top: -6px;'
        src="../../../../assets/images/icon_alarm.png">
      <span>您预约的{{ passEqment }}台设备已通过审批，请及时上机~</span>
    </div>
    <div class='msg_box'>
      <div class='left_box'>
        <div class='headerleft_msg'>
          <div style='font-family: Source Han Sans SC;font-weight: bold;font-size: 20px;color: #333333;'>
            信用扣分类型分布</div>
          <div>
            <span style='font-family: Source Han Sans SC;font-weight: 400;font-size: 16px;color: #999999;'>您当前的信用分</span>
            <span style='font-family: DIN;font-weight: 400;font-size: 32px;color: #FF9131;'>{{ creditScore }}</span>
          </div>
        </div>
        <div id="main" :style="{ width: '80%', height: '350px' }">
        </div>
      </div>
      <div class='right_box'>
        <div class='headerright_msg'>
          <span style='font-family: Source Han Sans SC;font-weight: bold;font-size: 18px;color: #333333;'>消息提醒</span>
          <div style='cursor: pointer' @click='e_showMessage'>
            <el-button size="mini" type="text"
              style='font-family: Source Han Sans SC;font-weight: 400;font-size: 14px;'>更多</el-button>
            <img style='vertical-align:middle;margin-top: -2px;' src="../../../../assets/images/icon_more.png">
          </div>
        </div>
        <div v-for='(item, index) in listData' :key='index' class='msg_boxsmall'>
          <div @click='toMessage'
            style='font-family: Source Han Sans SC;font-weight: 500;font-size: 16px;color: #333333;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;margin-bottom:24px;cursor: pointer;'>
            {{ item.content }}</div>
          <div style='font-family: Source Han Sans SC;font-weight: 400;font-size: 14px;color: #999999;'>
            {{ item.createTime }}</div>
        </div>
      </div>
    </div>
    <div class='examination_box'>
      <img @click='goExamination' style='width: 49%;cursor: pointer;' src="../../../../assets/images/img01.png">
      <img @click='goEqment' style='width: 49%;cursor: pointer;' src="../../../../assets/images/img02.png">
    </div>
    <div class='time_box'>
      <div class='titleBox'>
        <span>设备预约情况</span>
        <div
          style='font-family: Source Han Sans SC;font-weight: 400;font-size: 14px;color: #333333;display:flex;margin-right: 50px;'>
          <div
            style="width: 8px;height: 8px;border-radius:4px;background-color: #FF9131;white-space: nowrap;margin-right:60px">
            <div style='margin: -5px 0 0px 10px;'>已预约</div>
          </div>
          <div style="width: 8px;height: 8px;border-radius:4px;background-color: #1273FF;white-space: nowrap;">
            <div style='margin: -5px 0 0px 10px;'>已完成</div>
          </div>
        </div>
      </div>
      <div class='time_bottom'>
        <div class='left_tree'>
          <div class='treeHeader'>
            按设备分类
          </div>
          <el-tree :data="typeData" @node-click="typetreeClick" node-key="id" ref="typetree" highlight-current
            :props="defaultProps">
          </el-tree>
        </div>
        <div class='right_table'>
          <div class='weekBox'>
            <el-date-picker @change="getTimetable" v-model="date" format='yyyy-MM-dd' type="date"
              value-format='yyyy-MM-dd' placeholder="选择日期">
            </el-date-picker>
          </div>
          <el-table :data="tableData" border :cell-style="setColor" :cell-class-name="cellClassName">
            <el-table-column prop="equipmentNumber" label="编号" fixed="left" align="center">
            </el-table-column>
            <el-table-column prop="equipmentName" label="设备名称" fixed="left" align="center">
            </el-table-column>
            <el-table-column v-for='(item, index) in duringHeader' :key='index' :prop="item" width="75" :label="item"
              align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <message ref="message" v-if="showmessage" @close="showmessage = false" />
    <admissionExamination v-if='showadmissionExamination' :showadmissionExamination='showadmissionExamination'
      @close='showadmissionExamination = false'>
    </admissionExamination>
  </div>
</template>
<script>
import message from './dialog/message.vue'

export default {
  components: {
    message
  },
  data() {
    return {
      showmessage: false,
      passEqment: 2,
      creditScore: 0,
      creditEcharts: [],
      listData: [],
      showadmissionExamination: false,
      typeData: [],
      defaultProps: {
        label: 'nodeName',
        children: 'childList'
      },
      treeId: '',
      date: '',
      tableData: [],
      duringHeader: []
    }
  },
  methods: {
    init() {

      let data = {
        pageSize: 1000,
        pageNum: 1,
        readStatus: 0
      }
      this.$net(`/message/list`, 'get', data).then(res => {
        this.listData = res.data.list.length < 5 ? res.data.list : res.data.list.slice(0, 4)
      })
      this.$net('/sdau/personalCenter/data', 'get').then(res => {
        this.creditScore = res.data.creditScore
        this.passEqment = res.data.passEqment
        this.creditEcharts = res.data.creditEcharts
        this.getEcharts()
      })
      this.$net('/v1/userClient/home/selectEquipmentTree', 'get').then(res => {
        this.typeData = res.data
      })
    },
    getEcharts() {
      var myChart = this.$echarts.init(document.getElementById('main'));
      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        grid: { // 让图表占满容器
          top: "0px",
          left: "0px",
          right: "0px",
          bottom: "0px"
        },
        series: [
          {
            name: '扣分类型分布',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: this.creditEcharts
          }
        ]
      };
      myChart.setOption(option, true);
      window.addEventListener('resize', myChart.resize);
    },
    getTimetable(e) {
      this.date = e === undefined ? this.SDAU.getNowDate().split(' ')[0] : e
      let data2 = {
        treeId: this.treeId,
        searchDate: this.date
      }
      this.$net('/sdau/deviceReservation/queryManageList', 'get', data2).then(res => {
        this.tableData = res.data.manageReservationList
        this.duringHeader = res.data.dynamicHeader
      })
    },
    e_showMessage() {
      this.showmessage = true
      this.$nextTick(() => {
        this.$refs.message.init()
      })
    },
    typetreeClick() {
      this.treeId == '' ? this.treeId = this.$refs.typetree.getCurrentKey() : this.treeId == this.$refs.typetree.getCurrentKey() ? (this.$refs.typetree.setCurrentKey(null), this.treeId = '') : this.treeId = this.$refs.typetree.getCurrentKey()
      this.getTimetable()
    },
    toMessage() {
      this.showmessage = true
      this.$nextTick(() => {
        this.$refs.message.init(0)
      })
    },
    goExamination() {
      this.$net(`/sdau/userClient/appraisal/queryAdmissionExamPaper`, 'get').then(res => {
        this.showadmissionExamination = res.data.open
        if (!res.data.open) {
          this.$message({
            type: 'warning',
            message: '未开启准入考试'
          })
        }
      })
    },
    goEqment() {
      this.$router.push({ path: '/eqment' })
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    setColor({ row, column }) {
      if (![0, 1].includes(column.index)) {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].equipmentNumber == row.equipmentNumber && this.tableData[i].reservationList.map(obj => { return obj.timePeriodStr; }).includes(column.property)) {
            for (let j = 0; j < this.tableData[i].reservationList.length; j++) {
              let item = this.tableData[i].reservationList[j]
              if (item.timePeriodStr == column.property) return [0, 1, 5].includes(item.status) ? `background:#FF9131` : [4].includes(item.status) ? `background:#1273FF` : ``
            }
          }

        }
      }
    },
  },
  mounted() {
    this.getEcharts()
  },
  created() {
    this.init()
    this.getTimetable()

  },
}
</script>

<style lang="scss" scoped>
::v-deep.work_box {
  width: calc(95% - 200px);

  .tip_box {
    height: 64px;
    line-height: 64px;
    background: rgba(255, 246, 238, 0.39);
    border: 1px solid #ff9131;
    color: #ff9131;
    margin-bottom: 32px;
    padding-left: 32px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 18px;
  }

  .msg_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;

    .left_box {
      width: 49%;
      padding: 32px;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid #d7dce0;

      .headerleft_msg {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 80px;
      }
    }

    .right_box {
      width: 49%;
      padding: 32px;
      background-color: #ffffff;
      border: 1px solid #d7dce0;

      .headerright_msg {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #d7dce0;
        padding-bottom: 28px;
      }

      .msg_boxsmall {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: 24px;
      }
    }
  }

  .examination_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    background-color: #ffffff;
    border: 1px solid #d7dce0;
    margin-bottom: 32px;
  }

  .time_box {
    width: 100%;
    padding: 32px;
    background-color: #ffffff;
    border: 1px solid #d7dce0;

    .titleBox {
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      margin-bottom: 29px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .time_bottom {
      display: flex;
      justify-content: space-between;

      .left_tree {
        width: 25%;
        border: 1px solid #d7dce0;
        opacity: 1;
        margin-bottom: 32px;

        .treeHeader {
          background: #f6f6f6;
          height: 64px;
          font-size: 18px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #333333;
          padding-left: 32px;
          line-height: 64px;
        }
      }

      .right_table {
        width: 73%;

        .weekBox {
          width: 100%;
          background: rgba(246, 246, 246, 1.39);
          border: 1px solid #d7dce0;
          padding: 16px 0 16px 0;
          display: flex;
          justify-content: center;
        }
      }
    }
  }
}

.el-table tr td {
  height: 40px;
}
</style>